const basePixel = 16;
export const rem = (pixel) => {
    return pixel/basePixel + 'rem';
}